<template>
	<div id="page-container" class="main-content-boxed">
		<main id="main-container">
			<div :class="$page.component === 'Error' ? 'bg-danger' : 'bg-primary'">
				<div class="bg-body-extra-light">
					<div class="py-4 px-1 text-center">
						<inertia-link class="fw-bold" href="/">
							<img
								src="/media/logo/trc-logo-title.png"
								class="img-fluid"
								alt="trc-logo"
								style="width: 350px"
							/>
						</inertia-link>
						<h2 class="h6 fw-medium text-muted mb-0">
							{{ subtitle($page.component) }}
						</h2>
					</div>
					<div class="justify-content-center">
						<slot></slot>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script setup>
import { watch } from 'vue'
import { createToaster } from '@meforma/vue-toaster'

const props = defineProps({
	flash: Object,
})

const toast = createToaster()

const subtitle = (component) => {
	return {
		'Auth/Login': 'Please sign in',
		'Auth/Checkout': 'Account Enrollment',
		'Auth/ResetPassword': 'Reset Password',
		'Auth/SetPassword': 'Create a new password for your account',
		'Member/AccountExpired': 'Subscription Expired',
		DataPrivacyPolicy: 'Data Privacy Policy',
	}[component]
}

watch(
	() => props.flash,
	(flash) => {
		if (flash && flash.toast) {
			toast.show(flash.toast.msg, { type: flash.toast.type })
		}
	}
)
</script>
